import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@usimweb/core/services';

import { Meshing } from '@usimweb/core/models';
import { DialogService, InfoDialogComponent } from '@usimweb/ui/dialogs';

@Component({
    selector: 'app-cad-detail-dialog',
    templateUrl: './cad-detail-dialog.component.html',
    styleUrls: ['./cad-detail-dialog.component.scss'],
    standalone: false
})
export class CadDetailDialogComponent implements OnInit, AfterViewInit {
  public models: Meshing[] = [];
  public meshingModel: Meshing = {
    appType: '',
    title: '',
    stlFile: new File([], ''),
    modelKey: '',
    owner: '',
  };

  public appTypes = [{ key: '', value: '' }];
  public filterType = '';
  public filter: any = '';
  public showAll = false;
  public newFoaming = 'newFoaming';

  @Input() data = { uuid: '' };

  @Output() progressEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private dialogRef: MatDialogRef<CadDetailDialogComponent>,
    private apiService: ApiService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.getModels();
    this.getAppTypes();
  }

  private getAppTypes() {
    const subscription = this.apiService.getAppTypes().subscribe((result) => {
      subscription.unsubscribe();
      this.appTypes = result;
    });
  }

  private getModels(showAll = false) {
    const subscription = this.apiService.getGeometries(this.data.uuid, showAll).subscribe((response: Meshing[]) => {
      subscription.unsubscribe();
      this.models = response;
      this.progressEmitter.emit(false);
    });
  }

  openMesh(cardItem: any) {
    this.meshingModel.mesh = cardItem.uuid;
    this.meshingModel.project = this.data.uuid;

    const subscription = this.apiService.addFoamingMesh(this.meshingModel).subscribe((response: Meshing) => {
      subscription.unsubscribe();
      const dict = { id: response.uuid, title: response.title };
      this.dialogRef.close(dict);
    });
  }

  public filterTypeChangedEvent(value: string) {
    this.filterType = value;
  }

  public toggleGeometries(event: boolean) {
    console.log('geo');
    console.log(event);

    this.showAll = event;
    this.progressEmitter.emit(true);
    this.showAll === true ? this.getModels(this.showAll) : this.getModels();
  }

  public openAddCadDialog() {
    this.dialogRef.close({ openDialog: true });
  }

  public openDialog(event: any) {
    // const data = event.data;

    console.log('data');
    console.log(event);

    this.dialogService
      .openTextDialog(InfoDialogComponent, {}, 'Delete mesh', 'Delete', 'Are you sure you want to delete?')
      .subscribe((data: any) => {
        if (data) {
          this.apiService.deleteMesh(event.uuid).subscribe(() => {
            this.getModels();
          });
        }
      });
  }
  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue.trim().toLowerCase();
  }
}
